var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchbarSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5801 15.4449L18.7579 20.6161C19.2705 21.1281 20.1031 21.1279 20.6157 20.6158C21.1282 20.1034 21.1281 19.2717 20.6154 18.7595L15.441 13.5917C16.482 12.1773 17.0973 10.4304 17.0973 8.54082C17.0973 3.82682 13.267 0 8.54864 0C3.83033 0 0 3.82682 0 8.54082C0 13.2548 3.83033 17.0816 8.54864 17.0816C10.4289 17.0816 12.1681 16.4744 13.5801 15.4449ZM8.54871 2.6254C11.8167 2.6254 14.47 5.27622 14.47 8.54126C14.47 11.8063 11.8166 14.4571 8.54871 14.4571C5.28071 14.4571 2.62743 11.8062 2.62743 8.54126C2.62743 5.27637 5.28067 2.6254 8.54871 2.6254Z",
    fill: "#263B5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchbarSearch);
export default __webpack_public_path__ + "static/media/searchbar_search.704376f7548e78441972007f640a06ec.svg";
export { ForwardRef as ReactComponent };